import React from 'react';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modal from '../../../../components/modal'
import { Consumer } from '../../../../contextProvider/ContextProvider'

const BasicTable = props => {
  return (
    <Consumer>
      {
        (context) => {
          let color = context.state.themeStatus ? '#d83434' : '#4285F4'
          return (
            <MDBTable responsive>
              <MDBTableHead style={{ background: color }} textWhite>
                <tr>
                  <th></th>
                  <th>Website</th>
                  <th>Username</th>
                  <th>Password</th>
                  <th>URL</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                  <th>Action</th>

                </tr>
              </MDBTableHead>
              <MDBTableBody>
                {
                  props.passwords.map((val, index) => {
                    return <tr key={index}>
                      <td><img src={`https://logo-core.clearbit.com/${val[1].url}`} style={{ maxHeight: '40px' }} alt={val[1].website} /></td>
                      <td>{val[1].website}</td>
                      <td>{val[1].username}</td>
                      <td>{val[1].password}</td>
                      <td> {val[1].url}</td>
                      <td>{val[1].createdAt}</td>
                      <td>{val[1].updatedAt}</td>
                      <td><Modal
                        vault={props.vault} actions='editPassword'
                        modalTitle='Edit'
                        btnSize='sm'
                        usernameData={val[1].username}
                        passwordData={val[1].password}
                        urlData={val[1].url}
                        websiteData={val[1].website}
                        createdAtData={val[1].createdAt}
                        passwordId={val[0]}
                        btnTitle='edit' /></td>
                    </tr>
                  })
                }

              </MDBTableBody>
            </MDBTable>
          )
        }
      }
    </Consumer>
  );
}

export default BasicTable;